
<div>
  <div class="form-group">
    <label>Household:</label>
    <searchable-dropdown
      :o="$data"
      p="selectedHouseholdId"
      :items="households"
      itemText="name"
      itemValue="_id"
      placeholder="Select a household"
    />
    <small class="form-text text-muted">Select the household to generate report for all its accounts</small>
  </div>

  <div class="form-group">
    <label>Date Range:</label>
    <date-picker
      v-model="dateRange"
      :clearable="false"
      class="date-picker"
      format="MMM D, YYYY"
      range
    ></date-picker>
    <small class="form-text text-muted">Select start and end dates</small>
  </div>

  <div class="button-group">
    <button type="button" class="btn btn-outline-secondary action-button" @click="generateReport">
      <i class="fas fa-download mr-2"></i>Download Report
    </button>
  </div>
</div>
